<!-- Header da Pagina -->
<div class="page-header" *ngIf="!embutido">
  <div class="header-icon">
    <i class="pi pi-bookmark"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- TabView -->
<div class="tabs-container" [class.embutido]="embutido">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">
    <!-- Aba 1: Cadastro -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-plus-circle tab-icon"></i>
        <span>{{ texts.aba_cadastro }}</span>
      </ng-template>

      <div class="form-card">
        <div class="card-header">
          <div class="card-header-icon">
            <i class="pi pi-bookmark"></i>
          </div>
          <span class="card-header-title">{{ texts.add_nova_marca }}</span>
        </div>
        <div class="card-content">
          <div class="form-grid">
            <div class="form-field half">
              <label class="form-label">{{ labels.nome }} <span class="required">*</span></label>
              <input type="text" pInputText [(ngModel)]="form.nome"
                [placeholder]="placeholders.nome_da_marca"
                [class.error-field]="isFormSubmitted && !form.nome"
                class="w-full" />
            </div>
            <div class="form-field full">
              <label class="form-label">{{ labels.imagem }}</label>
              <p-fileUpload #fileUpload name="imagem" [multiple]="false" accept="image/*" [maxFileSize]="2000000"
                [showUploadButton]="false" [showCancelButton]="true"
                [chooseLabel]="botoes.selecionar_imagem"
                [cancelLabel]="botoes.remover" (onSelect)="onSelectImage($event)"
                (onClear)="onClearImage()">
              </p-fileUpload>

              <!-- Pre-visualizacao + nome do arquivo -->
              <div class="image-preview" *ngIf="imagePreviewUrl">
                <img [src]="imagePreviewUrl" class="preview-image" [attr.alt]="texts.pre_visualizacao" />
                <small class="filename">{{ fileName }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botoes de Acao -->
      <div class="actions-container">
        <button *ngIf="form.id" pButton [label]="botoes.limpar"
          severity="secondary" icon="pi pi-eraser"
          (click)="limparForm()" class="btn-secondary">
        </button>
        <button *ngIf="!form.id" pButton [label]="botoes.adicionar + ' (Ctrl+Enter)'"
          icon="pi pi-check" (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
        </button>
        <button *ngIf="form.id" pButton [label]="botoes.salvar + ' (Ctrl+Enter)'"
          icon="pi pi-check" (click)="salvarEdicaoDeMarca()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
        </button>
      </div>
    </p-tabPanel>

    <!-- Aba 2: Lista -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ texts.aba_lista }}</span>
      </ng-template>

      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-list"></i>
          </div>
          <span class="card-header-title">{{ texts.lista_de_marcas }}</span>
          <div class="card-header-actions">
            <button pButton [label]="botoes.nova_marca" icon="pi pi-plus"
              (click)="novaMarca()" class="btn-primary btn-sm"></button>
          </div>
        </div>
        <div class="card-content">
          <!-- Barra de pesquisa + Seletor de colunas -->
          <div class="search-bar">
            <p-iconField iconPosition="right" class="search-field">
              <p-inputIcon styleClass="pi pi-search" />
              <input #searchInput pInputText type="text"
                [placeholder]="placeholders.pesquisar"
                [(ngModel)]="searchNome"
                (ngModelChange)="onSearchChange($event)" />
            </p-iconField>

            <app-column-selector
              [columns]="columns"
              [storageKey]="STORAGE_KEY"
              (columnsChange)="onColumnsChange($event)">
            </app-column-selector>
          </div>

          <!-- Tabela -->
          <p-table [value]="marcas" [loading]="loading"
            (sortFunction)="customSort($event)" [customSort]="true"
            [tableStyle]="{ 'width': '100%' }">

            <ng-template pTemplate="header">
              <tr>
                <th [hidden]="!isColumnVisible('imagem')" style="width: 8%">
                  {{ labels.imagem }}
                </th>
                <th [hidden]="!isColumnVisible('codigoMarca')" pSortableColumn="codigoMarca" style="width: 18%">
                  {{ labels.codigo_marca }}<p-sortIcon [field]="'codigoMarca'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('nome')" pSortableColumn="nome" style="width: 37%">
                  {{ labels.nome }}<p-sortIcon [field]="'nome'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('criadoEm')" pSortableColumn="criadoEm" style="width: 22%">
                  {{ labels.data_da_inclusao }}<p-sortIcon [field]="'criadoEm'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('acoes')" style="width: 15%">{{ labels.acoes }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-marca>
              <tr>
                <td [hidden]="!isColumnVisible('imagem')" class="text-center">
                  <img *ngIf="marcaTemImagem(marca)"
                    [src]="getImagemUrl(marca.imagem)"
                    class="marca-thumbnail marca-thumbnail-clickable"
                    [alt]="marca.nome"
                    [pTooltip]="tooltips.ver_imagem"
                    tooltipPosition="top"
                    loading="lazy"
                    (click)="abrirDialogImagem(marca.imagem)"
                    (error)="onImageError($event)" />
                  <i *ngIf="marcaTemImagem(marca)" class="pi pi-image marca-thumbnail-placeholder" style="display: none"></i>
                  <i *ngIf="!marcaTemImagem(marca)" class="pi pi-image marca-thumbnail-placeholder"></i>
                </td>
                <td [hidden]="!isColumnVisible('codigoMarca')">{{ marca.codigoMarca }}</td>
                <td [hidden]="!isColumnVisible('nome')">{{ marca.nome }}</td>
                <td [hidden]="!isColumnVisible('criadoEm')">{{ formatarDataEHora(marca.criadoEm) }}</td>
                <td [hidden]="!isColumnVisible('acoes')" class="actions">
                  <button pButton icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-sm"
                    [pTooltip]="tooltips.editar" tooltipPosition="top"
                    (click)="editarMarca(marca)"></button>
                  <button *ngIf="!embutido" pButton icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-sm p-button-danger"
                    [pTooltip]="tooltips.excluir" tooltipPosition="top"
                    (click)="deletarMarca(marca.id)"></button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ texts.nenhum_marca }}</div>
                    <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ texts.carregando }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Paginacao -->
          <div class="pagination-container">
            <div>
              <p-paginator (onPageChange)="onPageChange($any($event))"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                [first]="first" [rows]="rows"
                [totalRecords]="totalRecords" [showFirstLastIcon]="true">
              </p-paginator>
            </div>
            <div class="flex align-items-center">
              <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
              <p-dropdown [options]="pageSizeOptions" optionLabel="label"
                optionValue="value" [(ngModel)]="rows"
                (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>

<!-- Dialog de Confirmacao de Exclusao (Wave Pattern) -->
<p-dialog
  [(visible)]="deleteDialogVisible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }"
  (onShow)="onDeleteDialogShow()">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmar_exclusao }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar + ' (Esc)'" class="p-button-secondary"
      (click)="deleteDialogVisible = false"></button>
    <button #deleteConfirmBtn pButton [label]="botoes.confirmar + ' (Enter)'" severity="danger" icon="pi pi-trash"
      style="gap: 0.35rem"
      (click)="confirmarExclusao()"></button>
  </ng-template>
</p-dialog>

<!-- Dialog de Imagem Expandida -->
<p-dialog [(visible)]="displayDialogImagem" [modal]="true" [closeOnEscape]="true" styleClass="expanded-marca-dialog">
  <div class="expanded-image-container">
    <img [src]="imagemExpandidaUrl" class="expanded-marca-image"
      (error)="onImagemExpandidaError($event)" />
  </div>
</p-dialog>

<p-toast />
